import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserValuesService } from 'src/app/services/utils/user-values.service';
import { ReporteService } from 'src/app/services/reporte.service';
import { ParamEntity } from 'src/app/models/general/param.model';

@Component({
  selector: 'app-reporting-tableros',
  templateUrl: './reporting-tableros.component.html',
  styleUrls: ['./reporting-tableros.component.css']
})
export class ReportingTablerosComponent implements OnInit, OnDestroy {
  metabaseUrl: SafeResourceUrl | null = null;
  paramEntity = new ParamEntity<any>();
  isLoading = true;
  isTakingLong = false;
  loadError: string | null = null;
  private loadWarningTimeout: ReturnType<typeof setTimeout> | null = null;
  private minimumLoadingTimeout: ReturnType<typeof setTimeout> | null = null;
  private postLoadTimeout: ReturnType<typeof setTimeout> | null = null;
  private minimumLoadingElapsed = false;
  private dashboardRenderDelayElapsed = false;

  constructor(
    private sanitizer: DomSanitizer,
    private userValuesService: UserValuesService, // Si necesitas obtener datos del usuario autenticado
    private reporteService: ReporteService
  ) { }

  async ngOnInit() {
    this.generarMetabaseUrl();
  }

  ngOnDestroy() {
    this.clearLoadWarningTimeout();
    this.clearMinimumLoadingTimeout();
    this.clearPostLoadTimeout();
  }

  private generarMetabaseUrl() {
    this.isLoading = true;
    this.isTakingLong = false;
    this.loadError = null;
    this.metabaseUrl = null;
    this.minimumLoadingElapsed = false;
    this.dashboardRenderDelayElapsed = false;
    this.clearLoadWarningTimeout();
    this.clearMinimumLoadingTimeout();
    this.clearPostLoadTimeout();
    this.loadWarningTimeout = setTimeout(() => this.isTakingLong = true, 15000);

    const paramEntity = new ParamEntity<any>();
    paramEntity.Json = JSON.stringify({ pParametro1: '' });

    this.reporteService.obtenerTokenMetabase(paramEntity).subscribe((response: any) => {
      if (response && response.url) {
        this.metabaseUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.url);
        // Metabase continues rendering asynchronously after the iframe's load event.
        this.minimumLoadingTimeout = setTimeout(() => {
          this.minimumLoadingElapsed = true;
          this.finishLoadingIfReady();
        }, 12000);
      } else {
        this.setLoadError('No se pudo obtener la URL del tablero.');
      }
    }, () => this.setLoadError('No se pudo conectar para cargar el tablero.'));
  }

  onDashboardLoad() {
    this.clearPostLoadTimeout();
    this.postLoadTimeout = setTimeout(() => {
      this.dashboardRenderDelayElapsed = true;
      this.finishLoadingIfReady();
    }, 2500);
  }

  onDashboardError() {
    this.setLoadError('No se pudo cargar el tablero.');
  }

  retryLoading() {
    this.generarMetabaseUrl();
  }

  private setLoadError(message: string) {
    this.isLoading = false;
    this.isTakingLong = false;
    this.loadError = message;
    this.clearLoadWarningTimeout();
    this.clearMinimumLoadingTimeout();
    this.clearPostLoadTimeout();
  }

  private finishLoadingIfReady() {
    if (!this.dashboardRenderDelayElapsed || !this.minimumLoadingElapsed) {
      return;
    }

    this.isLoading = false;
    this.isTakingLong = false;
    this.clearLoadWarningTimeout();
    this.clearMinimumLoadingTimeout();
    this.clearPostLoadTimeout();
  }

  private clearLoadWarningTimeout() {
    if (this.loadWarningTimeout) {
      clearTimeout(this.loadWarningTimeout);
      this.loadWarningTimeout = null;
    }
  }

  private clearMinimumLoadingTimeout() {
    if (this.minimumLoadingTimeout) {
      clearTimeout(this.minimumLoadingTimeout);
      this.minimumLoadingTimeout = null;
    }
  }

  private clearPostLoadTimeout() {
    if (this.postLoadTimeout) {
      clearTimeout(this.postLoadTimeout);
      this.postLoadTimeout = null;
    }
  }

}
